module.exports = __webpack_public_path__ + "img/_selected_green.d90e9d9c.svg";